import { createFileRoute, Navigate } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business Styling Consoleルートパスから/styling/overviewへの自動リダイレクト
 * @graph-connects none
 */
export const Route = createFileRoute('/styling/')({
  component: () => <Navigate to="/styling/overview" />,
});
